export const TYPES = {
  SET_BAILIFF_DOCUMENT_ALL: "bailiff_document/SET_BAILIFF_DOCUMENT_ALL",
  SET_BAILIFF_DOCUMENT_OPEN_ADD:
    "bailiff_document/SET_BAILIFF_DOCUMENT_OPEN_ADD",
  SET_BAILIFF_DOCUMENT_OPEN_EDIT:
    "bailiff_document/SET_BAILIFF_DOCUMENT_OPEN_EDIT",
  SET_BAILIFF_DOCUMENT_SELECTED:
    "bailiff_document/SET_BAILIFF_DOCUMENT_SELECTED",
  SET_BAILIFF_DOCUMENT_SEARCH: "bailiff_document/SET_BAILIFF_DOCUMENT_SEARCH",
  SET_BAILIFF_DOCUMENT_DETAIL: "bailiff_document/SET_BAILIFF_DOCUMENT_DETAIL",
  //
  SET_BAILIFF_DOCUMENT_EXTRACTING_COUNT:
    "bailiff_document/SET_BAILIFF_DOCUMENT_EXTRACTING_COUNT",

  //
  SET_BAILIFF_DOCUMENT_RAW: "bailiff_document/SET_BAILIFF_DOCUMENT_RAW",
  //
  SET_BAILIFF_DOCUMENT_SORT: "bailiff_document/SET_BAILIFF_DOCUMENT_SORT",
  //
  SET_BAILIFF_DOCUMENT_OPEN_PAY:
    "bailiff_document/SET_BAILIFF_DOCUMENT_OPEN_PAY",
  SET_BAILIFF_DOCUMENT_OPEN_UPLOAD:
    "bailiff_document/SET_BAILIFF_DOCUMENT_OPEN_UPLOAD",
  SET_BAILIFF_DOCUMENT_STEP: "bailiff_document/SET_BAILIFF_DOCUMENT_STEP",
  SET_BAILIFF_DOCUMENT_PER_UPLOAD:
    "bailiff_document/SET_BAILIFF_DOCUMENT_PER_UPLOAD",
  SET_BAILIFF_DOCUMENT_PER_PROGRESS:
    "bailiff_document/SET_BAILIFF_DOCUMENT_PER_PROGRESS",
  SET_BAILIFF_DOCUMENT_AUDIO: "bailiff_document/SET_BAILIFF_DOCUMENT_AUDIO",
  SET_BAILIFF_DOCUMENT_AUDIO_DURATION:
    "bailiff_document/SET_BAILIFF_DOCUMENT_AUDIO_DURATION",
  SET_BAILIFF_DOCUMENT_UPLOAD_COMPLETE:
    "bailiff_document/SET_BAILIFF_DOCUMENT_UPLOAD_COMPLETE",
  SET_BAILIFF_DOCUMENT_PROCCESS_COMPLETE:
    "bailiff_document/SET_BAILIFF_DOCUMENT_PROCCESS_COMPLETE",
  //deposit.
  SET_BAILIFF_DOCUMENT_DEPOSIT_JOB_ID:
    "bailiff_document/SET_BAILIFF_DOCUMENT_DEPOSIT_JOB_ID",
};
